import graphql__cf733c26e03885d1ecd0 from "./__generated__/ParticipativeModuleResultsFormFieldPie_result.graphql.js";import { graphql, useFragment } from "react-relay";

import ParticipativeModuleResultsFormFieldContainer from "./ParticipativeModuleResultsFormFieldContainer";
import ParticipativeModuleResultsFormFieldChoicesChart from "./ParticipativeModuleResultsFormFieldChoicesChart";
import { pieChartConfig } from "../../lib/charts/pieChart";

const ParticipativeModuleResultsFormFieldPie = props => {
  const result = useFragment(ParticipativeModuleResultsFormFieldPie_result, props.result);

  return (
    <ParticipativeModuleResultsFormFieldContainer {...props} result={result}>
      <ParticipativeModuleResultsFormFieldChoicesChart
        config={pieChartConfig}
        result={result}
      />
    </ParticipativeModuleResultsFormFieldContainer>
  );
};

const ParticipativeModuleResultsFormFieldPie_result = graphql__cf733c26e03885d1ecd0;

export default ParticipativeModuleResultsFormFieldPie;
